import React, { FC } from 'react';
import './AppFooterComponent.css';
import { colors } from '../../colors/Colors';
import Typography from '@mui/material/Typography';
import { Divider, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import { LocalizedLink } from '../localized-link/LocalizedLink';
import { PaymentBrandingComponent } from '../payment-branding/PaymentBrandingComponent';
import { isMonriCardPaymentEnabled } from '../../util/monriEligibility';
import whatsappViberIcon from '../../assets/whatsapp-viber.png';
import { openCookiePreferences } from '../../consent/cookieConsentApi';

export const AppFooterComponent: FC = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    // Dok Monri karticno placanje nije globalno odobreno (banka u verifikaciji),
    // u footeru sakrivamo logoe platnih kartica (VISA/MC/Maestro/DinaCard/AmEx)
    // jer ih vecina posetilaca ne moze koristiti — svi idu na IPS bankovni-transfer
    // tok. Ostali brand/secure logoi ostaju (Banca Intesa + Monri Payments + secure
    // protokoli) jer su globalni Monri partneri, ne vezani za konkretan kartica tok.
    const showCardLogos = isMonriCardPaymentEnabled();

    return (
        <>
            <div className="footer-container">
                <div className="column-container">
                    <Typography variant="h6" color={colors.background}>
                        {t('footer.start.title')}
                    </Typography>
                    <Divider
                        color={colors.background}
                        sx={{
                            marginBottom: '0.5rem',
                            marginTop: '0.5rem',
                            width: isMobile ? '50%' : '100%',
                        }}
                    />
                    <Typography variant="body1" color={colors.background}>
                        <LocalizedLink to="/trps">{t('footer.start.ourTherapists')}</LocalizedLink>
                    </Typography>
                    <Typography variant="body1">
                        <LocalizedLink to="/for-therapists">{t('footer.start.joinUs')}</LocalizedLink>
                    </Typography>
                    <Typography variant="body1">
                        <LocalizedLink to="/wellbeing">{t('footer.start.wellbeing')}</LocalizedLink>
                    </Typography>
                </div>
                <div className="column-container">
                    <Typography variant="h6" color={colors.background}>
                        {t('footer.policies.title')}
                    </Typography>
                    <Divider
                        color={colors.background}
                        sx={{
                            marginBottom: '0.5rem',
                            marginTop: '0.5rem',
                            width: isMobile ? '50%' : '100%',
                        }}
                    />
                    <Typography variant="body1">
                        <LocalizedLink to="/terms-of-use">
                            {t('footer.policies.termsOfUse')}
                        </LocalizedLink>
                    </Typography>
                    <Typography variant="body1">
                        <LocalizedLink to="/terms-of-use#privacy-policy">
                            {t('footer.policies.privacyPolicy')}
                        </LocalizedLink>
                    </Typography>
                    <Typography variant="body1" color={colors.background}>
                        <LocalizedLink to="/payment-instructions">
                            {t('footer.policies.paymentInstructions')}
                        </LocalizedLink>
                    </Typography>
                    <Typography variant="body1">
                        {/*
                            "Cookie preferences" link otvara vanilla-cookieconsent
                            Preferences Modal (videti src/consent/ConsentManager.tsx
                            koji exposuje window.openCookiePreferences). GDPR Art.
                            7(3): povlacenje saglasnosti mora biti jednako lako
                            kao i davanje.
                        */}
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a
                            href="#cookie-preferences"
                            onClick={(e) => {
                                e.preventDefault();
                                void openCookiePreferences();
                            }}
                            style={{ color: colors.background, textDecoration: 'underline', cursor: 'pointer' }}
                        >
                            {t('footer.policies.cookiePreferences')}
                        </a>
                    </Typography>
                </div>
                <div className="column-container">
                    <Typography variant="h6" color={colors.background}>
                        {t('footer.aboutUs.title')}
                    </Typography>
                    <Divider
                        color={colors.background}
                        sx={{
                            marginBottom: '0.5rem',
                            marginTop: '0.5rem',
                            width: isMobile ? '50%' : '100%',
                        }}
                    />
                    <Typography variant="body1">
                        <LocalizedLink to="/about">{t('footer.aboutUs.aboutPage')}</LocalizedLink>
                    </Typography>
                    <Typography variant="body1" color={colors.background}>
                        {t('footer.aboutUs.name')}
                    </Typography>
                    <Typography variant="body1" color={colors.background}>
                        {t('footer.aboutUs.address')}Bulevar Milutina Milankovica 7đ
                    </Typography>
                    <Typography variant="body1" color={colors.background}>
                        {t('footer.aboutUs.email')}info@balancepath.space
                    </Typography>
                    <Typography variant="body1" color={colors.background}>
                        {t('footer.aboutUs.phone')}+381605858061
                    </Typography>
                    <Typography
                        variant="body1"
                        color={colors.background}
                        component="div"
                        className="footer-phone"
                    >
                        <img
                            src={whatsappViberIcon}
                            alt="WhatsApp / Viber"
                            className="footer-phone-icon"
                        />
                        : +381605858061
                    </Typography>
                    <Typography variant="body1" color={colors.background}>
                        {t('footer.aboutUs.registrationNumber')}22145215
                    </Typography>
                    <Typography variant="body1" color={colors.background}>
                        {t('footer.aboutUs.taxNumber')}115348099
                    </Typography>
                    <Typography variant="body1" color={colors.background}>
                        {t('footer.aboutUs.notInVatSystem')}
                    </Typography>
                </div>
            </div>

            <div className="footer-payment">
                <PaymentBrandingComponent theme="on-dark" showTitle/>
            </div>

            <div className="copyright">
                <Typography
                    variant="body1"
                    color={colors.background}
                    sx={{ paddingBottom: '1rem' }}
                >
                    {t('footer.copyright')}
                </Typography>
            </div>
        </>
    );
};
